import React from "react";
import {
  Card,
  Typography,
  List,
  ListItem,
  ListItemPrefix,
  ListItemSuffix,
  Chip,
  Accordion,
  AccordionHeader,
  AccordionBody,
} from "@material-tailwind/react";
import {
  PresentationChartBarIcon,
  ShoppingBagIcon,
  UserCircleIcon,
  Cog6ToothIcon,
  InboxIcon,
  PowerIcon,
} from "@heroicons/react/24/solid";
import { LuHotel, LuPartyPopper } from "react-icons/lu";
import { FaQuestion } from "react-icons/fa6";
import { BiHotel } from "react-icons/bi";
import { ChevronRightIcon, ChevronDownIcon } from "@heroicons/react/24/outline";
import { SiBloglovin } from "react-icons/si";
import { FaPeopleGroup } from "react-icons/fa6";
import { IoIosInformationCircleOutline } from "react-icons/io";
import { GoHome } from "react-icons/go";
import Logo from "../../asset/logoblack.png"
import { IoChatbubbleEllipsesOutline } from "react-icons/io5";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../actions/userActions";
export function MultiLevelSidebar() {
  const [open, setOpen] = React.useState(0);
  const { error, loading, isAuthenticated, numberAdded,user,userProfile } = useSelector(
    (state) => state.user
  );
    const dispatch = useDispatch()
  const handleOpen = (value) => {
    setOpen(open === value ? 0 : value);
  };
  const userLogout = () =>{
    dispatch(logout())
  }
 
  return (
    <Card className="h-[100vh] fixed overflow-y-scroll  rounded-none  col-span-1 w-full max-w-[18rem] p-4">
      <div className="flex items-center justify-center my-6">
          <img className="w-[100px]" src={Logo} />

      </div>
      <List>
        <Accordion
          open={open === 1}
          icon={
            <ChevronDownIcon
              strokeWidth={2.5}
              className={`mx-auto h-4 w-4 transition-transform ${open === 1 ? "rotate-180" : ""}`}
            />
          }
        >
          <ListItem className="my-2 p-0" selected={open === 1}>
            <AccordionHeader onClick={() => handleOpen(1)} className="border-b-0 p-3">
              <ListItemPrefix>
                <LuHotel className="h-5 w-5" />
              </ListItemPrefix>
              <Typography color="blue-gray" className="mr-auto font-[NeueMedium] font-normal">
                Property
              </Typography>
            </AccordionHeader>
          </ListItem>
          <AccordionBody className="py-1">
            <List className="p-0">
            <Link to="/add-property" >
              <ListItem className="font-[NeueMedium]" >
                <ListItemPrefix>
                  <ChevronRightIcon strokeWidth={3} className="h-3 w-5" />
                </ListItemPrefix>
                Add Property
              </ListItem>
              </Link>
              <Link to="/properties" >
              <ListItem className="font-[NeueMedium]">
                <ListItemPrefix>
                  <ChevronRightIcon strokeWidth={3} className="h-3 w-5" />
                </ListItemPrefix>
                Total Properties
              </ListItem>
              </Link>
            </List>
          </AccordionBody>
        </Accordion>
        <Accordion
          open={open === 2}
          icon={
            <ChevronDownIcon
              strokeWidth={2.5}
              className={`mx-auto h-4 w-4 transition-transform ${open === 2 ? "rotate-180" : ""}`}
            />
          }
        >
          <ListItem className="my-2 p-0" selected={open === 2}>
            <AccordionHeader onClick={() => handleOpen(2)} className="border-b-0 p-3">
              <ListItemPrefix>
                <LuPartyPopper className="h-5 w-5" />
              </ListItemPrefix>
              <Typography color="blue-gray" className="mr-auto font-[NeueMedium] font-normal">
                Events
              </Typography>
            </AccordionHeader>
          </ListItem>
          <AccordionBody className="py-1">
            <List className="p-0">
            <Link to="/add-events" >
              <ListItem className="font-[NeueMedium]">
                <ListItemPrefix>
                  <ChevronRightIcon strokeWidth={3} className="h-3 w-5" />
                </ListItemPrefix>
                Add Events
              </ListItem>
              </Link>
              <Link to="/events">
              <ListItem className="font-[NeueMedium]">
                <ListItemPrefix>
                  <ChevronRightIcon strokeWidth={3} className="h-3 w-5" />
                </ListItemPrefix>
                All Events
              </ListItem>
              </Link>
            </List>
          </AccordionBody>
        </Accordion>
        <Accordion
          open={open === 3}
          icon={
            <ChevronDownIcon
              strokeWidth={2.5}
              className={`mx-auto h-4 w-4 transition-transform ${open === 3 ? "rotate-180" : ""}`}
            />
          }
        >
          <ListItem className="my-2 p-0" selected={open === 3}>
            <AccordionHeader onClick={() => handleOpen(3)} className="border-b-0 p-3">
              <ListItemPrefix>
                <BiHotel className="h-5 w-5" />
              </ListItemPrefix>
              <Typography color="blue-gray" className="mr-auto font-[NeueMedium] font-normal">
                Daily Stays
              </Typography>
            </AccordionHeader>
          </ListItem>
          <AccordionBody className="py-1">
            <List className="p-0">
            <Link to="/add-daily" >
              <ListItem className="font-[NeueMedium]">
                <ListItemPrefix>
                  <ChevronRightIcon strokeWidth={3} className="h-3 w-5" />
                </ListItemPrefix>
                Add Property
              </ListItem>
              </Link>
              <ListItem className="font-[NeueMedium]">
                <ListItemPrefix>
                  <ChevronRightIcon strokeWidth={3} className="h-3 w-5" />
                </ListItemPrefix>
                All Properties
              </ListItem>
            </List>
          </AccordionBody>
        </Accordion>
       <hr />
       <Accordion
          open={open === 4}
          icon={
            <ChevronDownIcon
              strokeWidth={2.5}
              className={`mx-auto h-4 w-4 transition-transform ${open === 4 ? "rotate-180" : ""}`}
            />
          }
        >
          <ListItem className="my-2 p-0" selected={open === 4}>
            <AccordionHeader onClick={() => handleOpen(4)} className="border-b-0 p-3">
              <ListItemPrefix>
                <GoHome className="h-5 w-5" />
              </ListItemPrefix>
              <Typography color="blue-gray" className="mr-auto font-[NeueMedium] font-normal">
                Home Carousel
              </Typography>
            </AccordionHeader>
          </ListItem>
          <AccordionBody className="py-1">
            <List className="p-0">
            <Link to="/home-content">
              <ListItem className="font-[NeueMedium]">
                <ListItemPrefix>
                  <ChevronRightIcon strokeWidth={3} className="h-3 w-5" />
                </ListItemPrefix>
                Add Home Carousel
              </ListItem>
              </Link>
              <Link to="/home-properties" >
              <ListItem className="font-[NeueMedium]">
                <ListItemPrefix>
                  <ChevronRightIcon strokeWidth={3} className="h-3 w-5" />
                </ListItemPrefix>
                All Home Carousel
              </ListItem>
              </Link>
            </List>
           
          </AccordionBody>
        </Accordion>
        <Accordion
          open={open === 5}
          icon={
            <ChevronDownIcon
              strokeWidth={2.5}
              className={`mx-auto h-4 w-4 transition-transform ${open === 5 ? "rotate-180" : ""}`}
            />
          }
        >
          <ListItem className="my-2 p-0" selected={open === 5}>
            <AccordionHeader onClick={() => handleOpen(5)} className="border-b-0 p-3">
              <ListItemPrefix>
                <IoChatbubbleEllipsesOutline className="h-5 w-5" />
              </ListItemPrefix>
              <Typography color="blue-gray" className="mr-auto font-[NeueMedium] font-normal">
                Testimonial
              </Typography>
            </AccordionHeader>
          </ListItem>
          <AccordionBody className="py-1">
            <List className="p-0">
            <Link to="/add-testimonial">
              <ListItem className="font-[NeueMedium]">
                <ListItemPrefix>
                  <ChevronRightIcon strokeWidth={3} className="h-3 w-5" />
                </ListItemPrefix>
                Add Testimonial
              </ListItem>
              </Link>
              <Link to="/testimonials">
              <ListItem className="font-[NeueMedium]">
                <ListItemPrefix>
                  <ChevronRightIcon strokeWidth={3} className="h-3 w-5" />
                </ListItemPrefix>
                All Testimonial
              </ListItem>
              </Link>
            </List>
          </AccordionBody>
        </Accordion>
        <Accordion
          open={open === 6}
          icon={
            <ChevronDownIcon
              strokeWidth={2.5}
              className={`mx-auto h-4 w-4 transition-transform ${open === 6 ? "rotate-180" : ""}`}
            />
          }
        >
          <ListItem className="my-2 p-0" selected={open === 6}>
            <AccordionHeader onClick={() => handleOpen(6)} className="border-b-0 p-3">
              <ListItemPrefix>
                <SiBloglovin className="h-5 w-5" />
              </ListItemPrefix>
              <Typography color="blue-gray" className="mr-auto font-[NeueMedium] font-normal">
                Blogs
              </Typography>
            </AccordionHeader>
          </ListItem>
          <AccordionBody className="py-1">
            <List className="p-0">
            <Link to="/add-blog">
              <ListItem className="font-[NeueMedium]">
                <ListItemPrefix>
                  <ChevronRightIcon strokeWidth={3} className="h-3 w-5" />
                </ListItemPrefix>
                Add Blog
              </ListItem>
              </Link>
              <Link to="/blogs">
              <ListItem className="font-[NeueMedium]">
                <ListItemPrefix>
                  <ChevronRightIcon strokeWidth={3} className="h-3 w-5" />
                </ListItemPrefix>
                All Blogs
              </ListItem>
              </Link>
            </List>
          </AccordionBody>
        </Accordion>
        <Accordion
          open={open === 7}
          icon={
            <ChevronDownIcon
              strokeWidth={2.5}
              className={`mx-auto h-4 w-4 transition-transform ${open === 7 ? "rotate-180" : ""}`}
            />
          }
        >
          <ListItem className="my-2 p-0" selected={open === 7}>
            <AccordionHeader onClick={() => handleOpen(7)} className="border-b-0 p-3">
              <ListItemPrefix>
                <FaQuestion className="h-5 w-5" />
              </ListItemPrefix>
              <Typography color="blue-gray" className="mr-auto font-[NeueMedium] font-normal">
                FAQs
              </Typography>
            </AccordionHeader>
          </ListItem>
          <AccordionBody className="py-1">
            <List className="p-0">
            <Link to="/add-faqs">
              <ListItem className="font-[NeueMedium]">
                <ListItemPrefix>
                  <ChevronRightIcon strokeWidth={3} className="h-3 w-5" />
                </ListItemPrefix>
                Add FAQs
              </ListItem>
              </Link>
              <Link to="/faqs">
              <ListItem className="font-[NeueMedium]">
                <ListItemPrefix>
                  <ChevronRightIcon strokeWidth={3} className="h-3 w-5" />
                </ListItemPrefix>
                All FAQs
              </ListItem>
              </Link>
            </List>
          </AccordionBody>
        </Accordion>
        <Accordion
          open={open === 8}
          icon={
            <ChevronDownIcon
              strokeWidth={2.5}
              className={`mx-auto h-4 w-4 transition-transform ${open === 8 ? "rotate-180" : ""}`}
            />
          }
        >
          <ListItem className="my-2 p-0" selected={open === 8}>
            <AccordionHeader onClick={() => handleOpen(8)} className="border-b-0 p-3">
              <ListItemPrefix>
                <GoHome className="h-5 w-5" />
              </ListItemPrefix>
              <Typography color="blue-gray" className="mr-auto font-[NeueMedium] font-normal">
                Home Properties
              </Typography>
            </AccordionHeader>
          </ListItem>
          <AccordionBody className="py-1">
            <List className="p-0">
            <Link to="/home-properties">
              <ListItem className="font-[NeueMedium]">
                <ListItemPrefix>
                  <ChevronRightIcon strokeWidth={3} className="h-3 w-5" />
                </ListItemPrefix>
                Add Home Properties
              </ListItem>
              </Link>
              <Link to="/home-list" >
              <ListItem className="font-[NeueMedium]">
                <ListItemPrefix>
                  <ChevronRightIcon strokeWidth={3} className="h-3 w-5" />
                </ListItemPrefix>
                All Home Properties
              </ListItem>
              </Link>
            </List>
           
          </AccordionBody>
        </Accordion>
        <Accordion
          open={open === 9}
          icon={
            <ChevronDownIcon
              strokeWidth={2.5}
              className={`mx-auto h-4 w-4 transition-transform ${open === 9 ? "rotate-180" : ""}`}
            />
          }
        >
          <ListItem className="my-2 p-0" selected={open === 9}>
            <AccordionHeader onClick={() => handleOpen(9)} className="border-b-0 p-3">
              <ListItemPrefix>
                <SiBloglovin className="h-5 w-5" />
              </ListItemPrefix>
              <Typography color="blue-gray" className="mr-auto font-[NeueMedium] font-normal">
               Articles
              </Typography>
            </AccordionHeader>
          </ListItem>
          <AccordionBody className="py-1">
            <List className="p-0">
            <Link to="/add-articles">
              <ListItem className="font-[NeueMedium]">
                <ListItemPrefix>
                  <ChevronRightIcon strokeWidth={3} className="h-3 w-5" />
                </ListItemPrefix>
                Add Articles
              </ListItem>
              </Link>
              <Link to="/blogs">
              <ListItem className="font-[NeueMedium]">
                <ListItemPrefix>
                  <ChevronRightIcon strokeWidth={3} className="h-3 w-5" />
                </ListItemPrefix>
                All Articles
              </ListItem>
              </Link>
            </List>
          </AccordionBody>
        </Accordion>
        <ListItem className="my-2 font-[NeueMedium]">
          <ListItemPrefix>
            <IoIosInformationCircleOutline className="h-5 w-5" />
          </ListItemPrefix>
          About Page
        </ListItem>
        <ListItem className="my-2 font-[NeueMedium]">
          <ListItemPrefix>
            <FaPeopleGroup className="h-5 w-5" />
          </ListItemPrefix>
          Community Page
        </ListItem>
         
        <ListItem onClick={userLogout} className="my-2 font-[NeueMedium]">
          <ListItemPrefix>
            <PowerIcon className="h-5 w-5" />
          </ListItemPrefix>
          Log Out
        </ListItem>
      </List>
    </Card>
  );
}